// removed by extract-text-webpack-plugin
module.exports = {"layout":"theme--layout--3rVeJuS6","content":"theme--content--PJxlGRIL","container":"theme--container--1S6cfoEI","warningBlock":"theme--warningBlock--CQGdIe9b","infoBlock":"theme--infoBlock--3rXhrV1P","blockIcon":"theme--blockIcon--2m4MbRNv","blockIcon__warning":"theme--blockIcon__warning--1KB6cAzh","blockIconWarning":"theme--blockIcon__warning--1KB6cAzh","blockIcon__info":"theme--blockIcon__info--2N-7SAnA","blockIconInfo":"theme--blockIcon__info--2N-7SAnA"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/HomeLayout/theme.scss
// module id = 1203
// module chunks = 0